// Weak-area prefill (readiness card → create-quiz loop-closer, follow-up to
// #522). The readiness card passes its thin-spot disciplines via ROUTER
// LOCATION STATE — ephemeral, per-navigation, nothing persisted (the
// client-persistence lifecycle rule: no naked localStorage).
//
// Resolution is deliberately conservative: only disciplines the categories
// endpoint actually knows survive, and an empty/garbage payload resolves to
// [] so populateCategories falls back to its normal prefs-vs-all behavior —
// a stale or malformed link can never produce a broken selection.
export const WEAK_AREA_STATE_KEY = "weakAreaDisciplines";

export const resolveWeakAreaPrefill = (locationState, totalDisciplineList) => {
  const requested = locationState?.[WEAK_AREA_STATE_KEY];

  if (!Array.isArray(requested) || !Array.isArray(totalDisciplineList)) {
    return [];
  }

  return requested.filter(
    (discipline) =>
      typeof discipline === "string" && totalDisciplineList.includes(discipline)
  );
};
